//
// Copyright (c) 2025 Comcast
//

import PropTypes from 'prop-types'
import Sidebar from './Index'

const WIDTH = 360

const RightSidebar = ({
  children, onClose, onBlur, title, noCloseButton, className, copyText, copyHtml,
  show = true, headerComponent, isPosAbsolute, tabIndex, onKeyDown,
  headerIcon, tabs, onTabChange, dataTest, copyTooltipText,
}) => {
  return (
    <Sidebar
      leftSide={false}
      width={WIDTH}
      onClose={onClose}
      onBlur={onBlur}
      title={title}
      noCloseButton={noCloseButton}
      className={className}
      copyText={copyText}
      copyHtml={copyHtml}
      copyTooltipText={copyTooltipText}
      show={show}
      headerComponent={headerComponent}
      isPosAbsolute={isPosAbsolute}
      tabIndex={tabIndex}
      onKeyDown={onKeyDown}
      headerIcon={headerIcon}
      tabs={tabs}
      onTabChange={onTabChange}
      dataTest={dataTest}
    >
      {children}
    </Sidebar>
  )
}

RightSidebar.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func,
  onBlur: PropTypes.func,
  title: PropTypes.string,
  noCloseButton: PropTypes.bool,
  copyText: PropTypes.string,
  copyHtml: PropTypes.string,
  copyTooltipText: PropTypes.string,
  show: PropTypes.bool,
  headerComponent: PropTypes.node,
  isPosAbsolute: PropTypes.bool,
  tabIndex: PropTypes.string,
  onKeyDown: PropTypes.func,
  headerIcon: PropTypes.node,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
    })
  ),
  onTabChange: PropTypes.func,
  dataTest: PropTypes.string,
}

export default RightSidebar
